class sliderCollection {
    constructor(element, options = {}){
        this.options = Object.assign(
            {},
            {  
                slideDesk : 4,
                slideDeskInc : 1,
                slideMob : 2,
                slideMobInc : 2,
                ruptDeskMob : 992
            }, 
            options
        );    
        this.slider = element; 
        this.sliderLeft = this.slider.querySelector(".left");
        this.sliderRight = this.slider.querySelector(".right");
        this.nbSlide = element.querySelectorAll(".slide").length;  
        this.currentSlide = 0;
        console.log(this.sizeSlide);

        window.addEventListener("resize", () => {
            this.reset();
        });

        this.gotoStep(this.currentSlide);

        this.sliderRight.addEventListener("click", () => {
            this.currentSlide += this.inc;
            this.gotoStep(this.currentSlide);
        });

        this.sliderLeft.addEventListener("click", () => {
            this.currentSlide -= this.inc;
            this.gotoStep(this.currentSlide);
        });
    }

    gotoStep(step){  
        let min = 0;
        let max = this.nbSlide - this.slidesVisible;
        console.group();
            console.log("step:" + step);
            console.log("max:" + max);
            console.log("min:" + min);
        console.groupEnd(); 
        if(step <= 0){
            this.currentSlide = 0;
            if(this.sliderRight.classList.contains("off")){
                this.sliderRight.classList.remove("off");
            } 
            if(!this.sliderLeft.classList.contains("off")){
                this.sliderLeft.classList.add("off");
            } 
        }
        if(step > 0){
            if(step >= max){
                this.currentSlide = max;
                if(!this.sliderRight.classList.contains("off")){
                    this.sliderRight.classList.add("off");
                } 
            }else{
                this.currentSlide = step;
            }
            if(this.sliderLeft.classList.contains("off")){
                this.sliderLeft.classList.remove("off")
            }  
        } 
        let translateX = -(this.sizeSlide * this.currentSlide ); 
        this.slider.querySelector(".products").style.transform = 'translateX(' + translateX + 'px) translate3d(0,0,0) translateZ(0)'; 
        this.slider.querySelector(".products").style.WebkitTransform = 'translateX(' + translateX + 'px) translate3d(0,0,0) translateZ(0)';  
    } 

    reset(){
        this.currentSlide = 0;
        this.gotoStep(0); 
    }

    get sizeSlide() { 
        return this.slider.querySelectorAll(".slide")[0].offsetWidth;
    }

    get sizeWindow() {
        return window.innerWidth;
    }

    get slidesVisible(){ 
        if(this.sizeWindow < this.options.ruptDeskMob){
            return this.options.slideMob;
        }else{
            return this.options.slideDesk;
        } 
    }

    get inc(){ 
        if(this.sizeWindow < this.options.ruptDeskMob){
            return this.options.slideMobInc;
        }else{
            return this.options.slideDeskInc;
        } 
    }
} 

let slidersCollection = [];
document.querySelectorAll(".content-collection-focus.slider").forEach((slider, index) => {
    slidersCollection[index] = new sliderCollection(slider);
});